import { useState, useEffect } from 'react';
import { Layout, Spin, Row, Col, Card, message, Tabs } from 'antd';
import { Chart } from 'react-google-charts';
import Sidebar from '../components/Sidebar';
import AppHeader from '../components/Header';
import { decryptData } from '../middleware/encryption';

const { Content } = Layout;
const { TabPane } = Tabs;

export default function Visualization() {
  const [collapsed, setCollapsed] = useState(false);
  const [loading, setLoading] = useState(true);
  const [countryData, setCountryData] = useState([]);
  const [industryData, setIndustryData] = useState([]);
  const [employeeSizeData, setEmployeeSizeData] = useState([]);
  const [departmentData, setDepartmentData] = useState([]);
  const [companyCountryData, setCompanyCountryData] = useState([]);
  const [companyIndustryData, setCompanyIndustryData] = useState([]);
  const [companyEmployeeSizeData, setCompanyEmployeeSizeData] = useState([]);
  const [companyRevenueData, setCompanyRevenueData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const myHeaders = new Headers();
        const token = sessionStorage.getItem('access_token');
        if (token) {
          myHeaders.append("Authorization", `Bearer ${token}`);
        }

        const requestOptions = {
          method: "GET",
          headers: myHeaders,
          redirect: "follow"
        };

        const [leadsResponse, companyResponse] = await Promise.all([
          fetch("https://api.app.exellius.com/api/leads/getPeopleLeadsDepartmentChartData", requestOptions),
          fetch("https://api.app.exellius.com/api/leads/getCompanyChartData", requestOptions)
        ]);

        const leadsResult = await leadsResponse.json();
        const companyResult = await companyResponse.json();

        if (leadsResult.data) {
          const decryptedLeadsResponse = decryptData(leadsResult.data).data;
          setDepartmentData(decryptedLeadsResponse.departments.map(item => [item[0], parseInt(item[1], 10)]));
          setCountryData(decryptedLeadsResponse.countries.map(item => [item[0], parseInt(item[1], 10)]));
          setIndustryData(decryptedLeadsResponse.industries.map(item => [item[0], parseInt(item[1], 10)]));
          setEmployeeSizeData(decryptedLeadsResponse.employee_sizes.map(item => [item[0], parseInt(item[1], 10)]));
        } else {
          message.error(leadsResult.message || "Failed to fetch leads data");
        }

        if (companyResult.data) {
          const decryptedCompanyResponse = decryptData(companyResult.data).data;
          setCompanyCountryData(decryptedCompanyResponse.location.map(item => [item[0], parseInt(item[1], 10)]));
          setCompanyIndustryData(decryptedCompanyResponse.industry.map(item => [item[0], parseInt(item[1], 10)]));
          setCompanyEmployeeSizeData(decryptedCompanyResponse.employee_size.map(item => [item[0], parseInt(item[1], 10)]));
        } else {
          message.error(companyResult.message || "Failed to fetch company data");
        }
      } catch (error) {
        console.error('Error fetching visualization data:', error);
        message.error("An error occurred while fetching visualization data");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return (
    <Layout style={{ minHeight: '125vh' }}>
      <Sidebar collapsed={collapsed} onCollapse={setCollapsed} />
      <Layout className="site-layout">
        <AppHeader />
        <Content style={{ margin: '0 16px', height: "calc(100vh - 64px)", overflowY: "scroll" }}>
          {loading ? (
            <Spin size="large" style={{ display: 'block', margin: 'auto', marginTop: '20%' }} />
          ) : (
            <Tabs defaultActiveKey="1">
              <TabPane tab="Leads" key="1">
                <Row gutter={[16, 16]}>
                  <Col xs={24} sm={12} md={12} lg={12}>
                    <Card title="Country">
                      <Chart
                        chartType="PieChart"
                        data={[['Country', 'Count'], ...countryData]}
                        options={{ title: 'Country Distribution' }}
                        width="100%"
                        height="400px"
                      />
                    </Card>
                  </Col>
                  <Col xs={24} sm={12} md={12} lg={12}>
                    <Card title="Industry">
                      <Chart
                        chartType="PieChart"
                        data={[['Industry', 'Count'], ...industryData]}
                        options={{ title: 'Industry Distribution' }}
                        width="100%"
                        height="400px"
                      />
                    </Card>
                  </Col>
                  <Col xs={24} sm={12} md={12} lg={12}>
                    <Card title="Employee Size">
                      <Chart
                        chartType="PieChart"
                        data={[['Employee Size', 'Count'], ...employeeSizeData]}
                        options={{ title: 'Employee Size Distribution' }}
                        width="100%"
                        height="400px"
                      />
                    </Card>
                  </Col>
                  <Col xs={24} sm={12} md={12} lg={12}>
                    <Card title="Departments">
                      <Chart
                        chartType="PieChart"
                        data={[['Department', 'Count'], ...departmentData]}
                        options={{ title: 'Department Distribution' }}
                        width="100%"
                        height="400px"
                      />
                    </Card>
                  </Col>
                </Row>
              </TabPane>
              <TabPane tab="Companies" key="2">
                <Row gutter={[16, 16]}>
                  <Col xs={24} sm={12} md={12} lg={12}>
                    <Card title="Country">
                      <Chart
                        chartType="PieChart"
                        data={[['Country', 'Count'], ...companyCountryData]}
                        options={{ title: 'Country Distribution' }}
                        width="100%"
                        height="400px"
                      />
                    </Card>
                  </Col>
                  <Col xs={24} sm={12} md={12} lg={12}>
                    <Card title="Industry">
                      <Chart
                        chartType="PieChart"
                        data={[['Industry', 'Count'], ...companyIndustryData]}
                        options={{ title: 'Industry Distribution' }}
                        width="100%"
                        height="400px"
                      />
                    </Card>
                  </Col>
                  <Col xs={24} sm={12} md={12} lg={12}>
                    <Card title="Employee Size">
                      <Chart
                        chartType="PieChart"
                        data={[['Employee Size', 'Count'], ...companyEmployeeSizeData]}
                        options={{ title: 'Employee Size Distribution' }}
                        width="100%"
                        height="400px"
                      />
                    </Card>
                  </Col>
                  <Col xs={24} sm={12} md={12} lg={12}>
                    
                  </Col>
                </Row>
              </TabPane>
            </Tabs>
          )}
        </Content>
      </Layout>
    </Layout>
  );
}

